import React, { useState } from 'react';
import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

export interface HeaderProfileMenuAction {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  color?: string;
  disabled?: boolean;
}

interface HeaderProfileMenuProps {
  initial?: string;
  actions: HeaderProfileMenuAction[];
  avatarBgColor?: string;
}

const HeaderProfileMenu: React.FC<HeaderProfileMenuProps> = ({
  initial = 'U',
  actions,
  avatarBgColor = '#c08a31',
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={openMenu} sx={{ p: 0 }}>
        <Avatar sx={{ width: 34, height: 34, bgcolor: avatarBgColor, fontWeight: 900 }}>
          {String(initial || 'U').charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.label}
            disabled={action.disabled}
            onClick={() => {
              if (action.disabled) return;
              closeMenu();
              action.onClick();
            }}
            sx={action.color ? { color: action.color } : undefined}
          >
            {action.icon ? <ListItemIcon>{action.icon}</ListItemIcon> : null}
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default HeaderProfileMenu;
